import { useAuthStore } from '../modules/users/stores/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();
  const token = useCookie('auth_token');

  // If token exists in cookie but not in store (refresh), set it and fetch user
  if (token.value && !authStore.token) {
      authStore.setToken(token.value);
  }
  
  if (authStore.token && !authStore.user) {
      await authStore.fetchUser();
  }

  const guestRoutes = ['/login', '/register'];

  if (!token.value && !guestRoutes.includes(to.path)) {
    return navigateTo('/login');
  }

  if (token.value && guestRoutes.includes(to.path)) {
    return navigateTo('/');
  }

  // 1. Regular users cannot enter /admin
  if (!authStore.isSuperAdmin && to.path.startsWith('/admin')) {
      return navigateTo('/');
  }

  // Redirect to business setup if user has no business (except Super Admin)
  if (authStore.token && authStore.user && !authStore.user.business_id && !authStore.isSuperAdmin && to.path !== '/setup-business') {
    return navigateTo('/setup-business');
  }

  // ACL & Feature Access Logic
  if (authStore.user) {
      if (to.meta.feature && !authStore.hasFeature(to.meta.feature as string)) {
          // You might want a dedicated 403 page, but home is safe fallback
          return navigateTo('/');
      }
      
      if (to.meta.permission && !authStore.hasPermission(to.meta.permission as string)) {
          return navigateTo('/');
      }
  }
});
